<div fxLayout="column">
  <div *ngIf="label.length > 0" class="input-label">{{ label }}</div>
  <app-date-picker
    [minDate]="minDate"
    [isTwoWeeksMaxDate]="isTwoWeeksMaxDate"
    [maxDate]="maxDate"
    [isNextWeekMinDate]="isNextWeekMinDate"
    [isTodayMinDate]="isTodayMinDate"
    [isOnlyMonday]="isOnlyMonday"
    [isOnlyFriday]="isOnlyFriday"
    [disabled]="disabled"
    [formCtrl]="formCtrl"
    (dateChanged)="changeDay($event)"
    [fromMon2Fri]="fromMon2Fri"
    [day]="day"
    [placeholder]="placeholder"
  ></app-date-picker>
  <div class="input-hint-message" *ngIf="hintMessage.length > 0">{{ hintMessage }}</div>
</div>
